import axios from "axios";
import React, { useState } from "react";
import SideNavbar from "./helpers/SideNavbar";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";

const CreatePoll = () => {
  const [question, setQuestion] = useState("");
  const [options, setOptions] = useState(["", ""]);
  const [duration, setDuration] = useState(3); // default 3 days
  const [message, setMessage] = useState("");
    const accessToken = localStorage.getItem('AccessToken');
    const AccountType = localStorage.getItem('AccountType');
    const userProfile = JSON.parse(localStorage.getItem("userProfile")) ||[] ;
    const LinkedinTokenid = userProfile ? userProfile[0]?.Tokenid : null;
    const RoleID = localStorage.getItem('RoleID');
    const tokenID = localStorage.getItem('Tokenid');
const [prompt, setPrompt] = useState("");
const [loading, setLoading] = useState(false); // Optional: for loading spinner

const resetForm = () => { 
  setQuestion("");
  setOptions(["", ""]);
  setDuration(3);
  setMessage("");
};

  const handleOptionChange = (index, value) => {
    const updated = [...options];
    updated[index] = value;
    setOptions(updated);
  };

  const addOption = () => {
    if (options.length < 4) setOptions([...options, ""]);
  };

  const removeOption = (index) => {
    if (options.length > 2) {
      const updated = options.filter((_, i) => i !== index);
      setOptions(updated);
    }
  };

  const handleSubmit = async () => {
    // normalize options: trim and enforce <= 30 characters
    const normalizedOptions = options
      .map(opt => (opt || "").trim())
      .filter(opt => opt !== "");

    const tooLongOptions = normalizedOptions.filter(opt => opt.length > 30);
    if (tooLongOptions.length > 0) {
      Swal.fire("Error", "Each option must be 30 characters or less.", "warning");
      return;
    }

    const validOptions = normalizedOptions;
    if (!question.trim() || validOptions.length < 2) {
      setMessage("Please enter a question and at least two options.");
      return;
    }

    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/createPoll`
, {
        question,
        options: validOptions,
        durationDays: duration,
        accessToken:accessToken ,
        AccountType: AccountType,
        Tokenid:  RoleID==1 ? LinkedinTokenid : tokenID,
        UserID: localStorage.getItem('UserID') // ✅ Add UserID for usage logging

      });

    if(response.data.message=='Poll posted successfully')
    {
     Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Poll posted successfully',
                        showConfirmButton: false,
                        timer: 3000
                    });
                    resetForm();
                    
                    // 🔄 Refresh feature usage data to show updated limits
                    if (window.refreshFeatureUsage) {
                      window.refreshFeatureUsage();
                    }
                  }
  };

const handleGeneratePoll = async (promptText) => {
  try {
    setLoading(true);

    const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/generate-poll`, { prompt: promptText });

    if (res.data?.newContent?.question && res.data?.newContent?.options) {
      setQuestion((res.data.newContent.question || "").trim());
      // trim and cap options to 30 chars, max 4 options
      const cleaned = (res.data.newContent.options || [])
        .slice(0, 4)
        .map(o => (o || "").trim())
        .filter(o => o.length > 0)
        .map(o => (o.length > 30 ? o.slice(0, 30) : o));
      setOptions(cleaned.length ? cleaned : ["", ""]);
      if ((res.data.newContent.options || []).some(o => (o || "").trim().length > 30)) {
        Swal.fire("Notice", "Some AI-generated options were truncated to 30 characters.", "info");
      }
    } else {
      Swal.fire("Error", "Invalid response from poll generation API", "error");
    }
  } catch (err) {
    console.error(err);
    Swal.fire("Error", "Failed to generate poll. Please try again.", "error");
  } finally {
    setLoading(false);
  }
};



  return (
<SideNavbar> 
      <div className="card shadow-sm p-3 mt-3" style={{ border: 'none', backgroundColor: '#fff' }}>
                        <div className="card-header" style={{ border: 'none', backgroundColor: '#fff' }}>
                        <Link to={localStorage.getItem('RoleID') == '4' ? '/Pagehome' : (localStorage.getItem('RoleID') == '1' ? '/home' : '/adminhome')}>
                        <h5 className="welcome-text" style={{ fontSize: '20px', color: '#2e3192', textAlign: 'left' }}><i class="fa fa-arrow-left" style={{marginRight:'30px'}}aria-hidden="true"></i>Create Poll</h5>
                          </Link>
                                              </div>
     <hr />
<div className="card p-3 shadow-lg" style={{width:550, margin:'auto',border:'none'}}> 
     <input
  type="text"
  value={prompt}
  onChange={e => setPrompt(e.target.value)}
  className="form-control mb-3"
  placeholder="Enter prompt to generate poll question (e.g.,AI, elections)"
/>
<div className="text-center">
<button
  type="button"
  className="btn btn-primary mb-3"
  onClick={() => handleGeneratePoll(prompt)}
>
  Generate Poll Question
</button>
</div>
 <textarea
        value={question}
       onChange={e => setQuestion(e.target.value)}
            style={{
              fontSize: '15px',
              borderRadius: '8px',
              border: '1px solid #cfeafb',
              background: '#FFFFFF',
              height: '100px',
              width: "100%",
              padding: '0px 20px',
              fontSize: '16px',
            }}
              placeholder="Poll question"
          />

 {options.map((opt, idx) => ( 
  <div key={idx} className="d-flex align-items-center mt-2">
    <input
      type="text"
      className="form-control me-2"
      placeholder={`Option ${idx + 1}`}
      value={opt}
      maxLength={30}  // <-- limit input length in UI
      onChange={e => {
        const newValue = e.target.value;
        if (newValue.length <= 30) {
          handleOptionChange(idx, newValue);
        }
      }}
    />
      
    {options.length > 2 && (
      <i
        className="fa fa-trash text-danger"
        style={{ cursor: "pointer" }}
        title="Remove Option"
        onClick={() => removeOption(idx)}
      ></i>
    )}
  </div>
))}
<div>
  {options.length < 4 && <button style={{backgroundColor:'#2e3192'}} onClick={addOption}> <i
        className="fa fa-plus text-white"
        style={{ cursor: "pointer" }}
        title="Add Option"
      ></i></button>}
</div>
    <label className="mt-3 d-block">
      Duration:
      <select
        value={duration}
        onChange={e => setDuration(parseInt(e.target.value))}
      className="form-control me-2"
      >
        <option value={1}>1 Day</option>
        <option value={3}>3 Days</option>
        <option value={7}>1 Week</option>
        <option value={14}>2 Weeks</option>
      </select>
    </label>

    <br />
<div className="text-center">
       <button type="submit" onClick={handleSubmit} style={{ backgroundColor: "#2e3192",borderRadius:8, marginTop: 20 }}>
                           Post Poll
                        </button>
                        </div>
  </div>
</div>
</SideNavbar>

  );
};

export default CreatePoll;